import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo13/maderaselva.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad2Actividad6.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[7];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[8].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[8].path}`,
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[6].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[6].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>Trabaja con un compañero, compañera o familiar.</li>
        <li>Lean el siguiente caso y observen la ilustración.</li>
      </ul>

      <div className="row align-items-center">
        <div className="col-md-6 col-12">
          <p className="fs-5">
            Las áreas naturales protegidas son espacios reconocidos por el
            Estado por su importancia para la conservación de la diversidad
            ecológica en el Perú. Existen áreas protegidas en la selva
            amazónica, donde, entre otras cosas, está prohibido talar madera. A
            pesar de eso, la empresa “Maderas Selva” extrae madera de una zona
            protegida de la Amazonía peruana. Para ello, ha contratado a varias
            decenas de pobladores de la zona.
          </p>
        </div>
        <div className="col-md-6 col-12">
          <img src={Imagen1} className="img-fluid" alt="Peruanos" />
        </div>
      </div>

      <ul className="mt-5">
        <li>Ahora, conversen acerca de lo siguiente: </li>
      </ul>

      <div className="row">
        <div className="col-lg-10 col-12">
          <p>¿Cuál es el problema que nos presenta el texto?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>¿Qué es lo que está haciendo mal la empresa “Maderas Selva”?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>¿Qué podría hacer el Estado para solucionar el problema?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>
            ¿Piensan que es correcto que los pobladores de la zona trabajen para
            la empresa?
          </p>
          <textarea className="form-control" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que las actividades que realizarán a continuación buscan
            desarrollar la capacidad de dialogar sobre la problemática de
            nuestro entorno.
          </li>
          <li>
            Lea las dos primeras indicaciones: Trabaja con un compañero o
            compañera. Lean el siguiente caso y observen la ilustración. Pida a
            un o una estudiante que describa en voz alta la ilustración y luego
            pida a otro que lea en voz alta el caso.
          </li>
          <li>
            Lea la siguiente indicación: Ahora, conversa con tu compañero o
            compañera acerca de lo siguiente: - ¿Cuál es el problema que nos
            presenta el texto? - ¿Qué es lo que está haciendo mal la empresa
            “Maderas Selva”? - ¿Qué podría hacer el Estado para solucionar el
            problema? - ¿Piensan que es correcto que los pobladores de la zona
            trabajen para la empresa?
          </li>
          <li>
            Dé un tiempo para que trabajen en las preguntas. Pídales que
            sustenten sus respuestas para lo cual pueden utilizar las siguientes
            expresiones:
            <ul>
              <li>
                <i>
                  “Yo pienso que… porque... - Estoy de acuerdo contigo porque… -
                  No estoy de acuerdo con lo que dices porque yo pienso que…”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Retome algunas de las respuestas. Por ejemplo:
            <ul>
              <li>
                <i>
                  “¿Cuál es el problema que nos presenta el texto? (Posible
                  respuesta: La extracción ilegal de madera en la selva).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué es lo que está haciendo mal la empresa “Maderas Selva”?
                  (Posible respuesta: Está extrayendo madera de una zona
                  protegida de la Amazonía).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué podría hacer el Estado para solucionar el problema?
                  (Posible respuesta: El Estado debe establecer sanciones para
                  la empresa y los pobladores que trabajen para ella. Asimismo,
                  debe capacitar a los pobladores locales sobre la importancia
                  de la conservación de los bosques, de tal manera que asuman un
                  rol vigilante ante la tala ilegal.
                </i>
              </li>
              <li>
                <i>
                  ¿Piensan que es correcto que los pobladores de la zona
                  trabajen para la empresa? (Posible respuesta: No es correcto
                  pues se trata de una actividad ilegal que daña su entorno).”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Cierre la actividad señalando que la tala ilegal es un problema
            frecuente en nuestro país. La actividad forestal, si se realiza de
            acuerdo a ley, puede ser muy beneficiosa para las poblaciones
            locales.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
